import React from 'react';
import { Link } from 'react-router-dom';
import '../Section.css';
import '../../App.css';
import './RecordingPage.css';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations';

import RecordingCarousel from '../RecordingCarousel';
import RecordingBottomCarousel from '../RecordingBottomCarousel';

function RecordingPage() {
  const { language } = useLanguage();

  return (
    <div className="page recording-page">
      {/* Top carousel with halftone background */}
      <div className="halftone-bg xfade-section">
        <RecordingCarousel />
      </div>

      {/* Full-width black textbox */}
      <div className="full-width-text-panel">
        <p>
          {t('recording.para1', language)}
        </p>
      </div>

      {/* Bottom carousel with halftone background */}
      <div className="halftone-bg xfade-section">
        <RecordingBottomCarousel />
      </div>

      {/* Another full-width black textbox */}
      <div className="full-width-text-panel">
        <p>
          {t('recording.para2', language)}
        </p>
      </div>

      {/* Bio section with halftone background */}
      <div className="bio-halftone">
        <div className="rail recording-bio-section">
          <img
  src="/images/robbie_studio.jpg"
  alt="Robbie Moore"
  className="bio-image"
  width="1500"
  height="1000"
/>
          <div className="bio-text-panel">
            <p>
              {t('recording.bio', language)}
              <br />
              {t('recording.bioCredits', language)}
            </p>
          </div>
        </div>
      </div>

      {/* Pink collaboration textbox */}
      <div className="collaboration-panel">
        <p>
          {t('recording.hireLine1', language)}
          <br />
          {t('recording.hireLine2', language)} <Link to="/contact" className="inline-link" onClick={() => window.scrollTo(0, 0)}>{t('recording.here', language)}</Link> {t('recording.hireLine2Suffix', language)}
        </p>
      </div>

      {/* Floorplan section with black background */}
      <div className="floorplan-section">
        <div className="floorplan-container">
          <img
            src={process.env.PUBLIC_URL + '/images/recording/rec_floorplan.png'}
            alt="Recording Studio Floorplan"
            className="floorplan-image"
          />
        </div>
      </div>

      {/* PDF embed section with halftone background */}
      <div className="pdf-embed-section pdf-halftone">
        <div className="rail pdf-container">
          <img
            src="/documents/Idea_Farm_Studio_Equip_List_1.png"
            alt="Studio Equipment List 1"
            className="pdf-image"
            loading="lazy"
          />
          <img
            src="/documents/Idea_Farm_Studio_Equip_List_2.png"
            alt="Studio Equipment List 2"
            className="pdf-image"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}

export default RecordingPage;
